const handleImageRotation = (resize = false, set = null) =>{
    if(document.querySelector('.has-rotating-images')){
        const isReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

        if(set !== null){
            for (const item of set) {
                clearInterval(item);
            }
        }
        const setOfIntervals = new Set();
        if(false === isReduced.matches){
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            const allCoverWithRotation = document.querySelectorAll('.has-rotating-images');
            allCoverWithRotation.forEach(c =>{
                let start = c.querySelector('.csp-rotate-image-zero');
                let middle = c.querySelector('.csp-rotate-image-one');
                let middleMobileSrc = middle ? middle.getAttribute('data-rotate-mobile-src') : '';
                let middleSrc = middle ? middle.getAttribute('data-rotate-src') : '';
                let end  = c.querySelector('.csp-rotate-image-two');
                let endMobileSrc = end ? end.getAttribute('data-rotate-mobile-src') : '';
                let endSrc = end ? end.getAttribute('data-rotate-src') : '';
                middle.classList.remove('d-none');
                end.classList.remove('d-none');
                if(vw > 1024){
                    middle.src = middleSrc;
                    end.src = endSrc;
                }
                if(vw < 1025){
                    middle.src = middleMobileSrc;
                    end.src = endMobileSrc;
                }
                let currentlyActive = start;
                const skipInterval = setInterval(() => {currentlyActive = skipToNext()}, 3500)
                setOfIntervals.add(skipInterval);
                const skipToNext = () => {
                    if(currentlyActive === start){
                        start.classList.add('csp-rotate-image-hidden');

                        middle.classList.remove('csp-rotate-image-hidden');
                        return middle;
                    }
                    if(currentlyActive === middle){
                        middle.classList.add('csp-rotate-image-hidden');

                        end.classList.remove('csp-rotate-image-hidden');
                        return end;
                    }
                    if(currentlyActive === end){
                        end.classList.add('csp-rotate-image-hidden');

                        start.classList.remove('csp-rotate-image-hidden');
                        return start;
                    }
                }

            })
        }


        return setOfIntervals;
    }
}
export default handleImageRotation;